module.exports = __webpack_public_path__ + "media/scholarship_winners/shally-sw-dd33edf0.png";